import { temAcesso } from '@/shared/auth/temAcesso'

const Relatorios = () => import('./Relatorios.vue')
const ComprometimentosSemRegistroPagamento = () =>
    import('./ComprometimentosSemRegistroPagamento.vue')
const RelacaoNotasFiscais = () => import('./RelacaoNotasFiscais.vue')
const ComprometimentosPorContrato = () =>
    import('./ComprometimentosPorContrato.vue')
const ContratosPorGestor = () => import('./ContratosPorGestor.vue')
const ValoresPagosPorContratos = () => import('./ValoresPagosPorContratos.vue')
const MovimentacoesMinimas = () => import('./MovimentacoesMinimas.vue')
const RelatorioLAI = () =>
    import('./RelatorioLAI.vue')
const RelatorioIJ = () =>
    import('./RelatorioIJ.vue')
const RelatorioOrcamentoEResultados = () =>
    import('./RelatorioOrcamentoEResultados.vue')
const Geral = () => import('./RelatorioGeral.vue')

export default {
    path: 'contratos/relatorios',
    name: 'Contratos_Relatorios',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-REL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'geral',
            name: 'Contratos_Relatorios_Geral',
            component: Geral,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-07')) {
                    next()
                }
            }
        },
        {
            path: 'comprometimentossemregistropagamento',
            name: 'Contratos_Relatorios_ComprometimentosSemRegistroPagamento',
            component: ComprometimentosSemRegistroPagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-01')) {
                    next()
                }
            }
        },
        {
            path: 'relacaonotasfiscais',
            name: 'Contratos_Relatorios_RelacaoNotasFiscais',
            component: RelacaoNotasFiscais,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-02')) {
                    next()
                }
            }
        },
        {
            path: 'comprometimentosporcontrato',
            name: 'Contratos_Relatorios_ComprometimentosPorContrato',
            component: ComprometimentosPorContrato,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-03')) {
                    next()
                }
            }
        },
        {
            path: 'contratosporgestor',
            name: 'Contratos_Relatorios_ContratosPorGestor',
            component: ContratosPorGestor,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-04')) {
                    next()
                }
            }
        },
        {
            path: 'valorespagosporcontratos',
            name: 'Contratos_Relatorios_ValoresPagosPorContratos',
            component: ValoresPagosPorContratos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-05')) {
                    next()
                }
            }
        },
        {
            path: 'movimentacoesminimas',
            name: 'Contratos_Relatorios_MovimentacoesMinimas',
            component: MovimentacoesMinimas,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-06')) {
                    next()
                }
            }
        },
        {
            path: 'contratos-lai',
            name: 'Contratos_Relatorios_LAI_Filtro',
            component: RelatorioLAI,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-08')) {
                    next()
                }
            }
        },
        {
            path: 'contratos-lai/:cnpj',
            name: 'Contratos_Relatorios_LAI',
            component: RelatorioLAI,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-08')) {
                    next()
                }
            }
        },
        {
            path: 'contratos-ij',
            name: 'Contratos_Relatorios_IJ_Filtro',
            component: RelatorioIJ,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-09')) {
                    next()
                }
            }
        },
        {
            path: 'contratos-ij/:cnpj',
            name: 'Contratos_Relatorios_IJ',
            component: RelatorioIJ,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-09')) {
                    next()
                }
            }
        },
        {
            path: 'orcamento-e-resultados',
            name: 'Contratos_Relatorios_OrcamentoEResultados_Filtro',
            component: RelatorioOrcamentoEResultados,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-10')) {
                    next()
                }
            }
        },
        {
            path: 'orcamento-e-resultados/:cnpj',
            name: 'Contratos_Relatorios_OrcamentoEResultados',
            component: RelatorioOrcamentoEResultados,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-10')) {
                    next()
                }
            }
        }
    ]
}
